"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  width: 100%;\n  padding: ", ";\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-family: ", ";\n  border: 1px solid ", ";\n  border-radius: 5px;\n  max-width: 100rem;\n  cursor: ", ";\n\n  section {\n    flex: 1 0 auto;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-wrap: wrap;\n\n    > div:not(:last-of-type) {\n      margin-right: 50px;\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n    border: 1px solid ", ";\n    cursor: pointer;\n\n    & ", " span {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 auto;\n\n  .label {\n    font-weight: normal;\n    font-size: 1.4rem;\n    line-height: 2rem;\n    color: ", ";\n  }\n\n  .data {\n    color: #505050;\n    font-weight: bold;\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n  }\n\n  &.double {\n    flex: 2 0 auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// import { QuickActionSubMenu } from '../Navigation/index';
var RiskObjectBarDataGroup = function RiskObjectBarDataGroup(_ref) {
  var label = _ref.label,
      data = _ref.data,
      size = _ref.size,
      children = _ref.children;
  return _react.default.createElement(RiskObjectBarData, {
    className: size
  }, _react.default.createElement("span", {
    className: "label"
  }, label), _react.default.createElement("span", {
    className: "data"
  }, data), children);
};

RiskObjectBarDataGroup.propTypes = {
  label: _propTypes.string,
  data: _propTypes.string,
  children: _propTypes.node,
  size: _propTypes.string
};

var RiskObjectBar = function RiskObjectBar(_ref2) {
  var icon = _ref2.icon,
      children = _ref2.children,
      isDragItem = _ref2.isDragItem,
      onClick = _ref2.onClick,
      otherProps = _objectWithoutProperties(_ref2, ["icon", "children", "isDragItem", "onClick"]);

  var IconToRender;

  if (icon !== '') {
    IconToRender = _react.default.createElement(RiskObjectBarIcon, null, icon);
  }

  return _react.default.createElement(RiskObjectBarContainer, _extends({
    onClick: onClick,
    isDragItem: isDragItem
  }, otherProps), _react.default.createElement("section", null, IconToRender, children));
};

var RiskObjectBarData = _styledComponents.default.div(_templateObject(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.labels.defaultText;
});

var RiskObjectBarContainer = _styledComponents.default.div(_templateObject2(), function (_ref4) {
  var isDragItem = _ref4.isDragItem;
  return isDragItem === true ? '25px 25px 25px 45px' : '25px';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.ui.outline;
}, function (_ref7) {
  var onClick = _ref7.onClick;
  return onClick !== undefined ? 'pointer' : 'auto';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.brand.lightest;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.brand.primary;
}, RiskObjectBarData, function (_ref10) {
  var theme = _ref10.theme;
  return theme.brand.primary;
});

RiskObjectBar.propTypes = {
  /** The name of the icon to be shown. No icon will be shown if left empty. */
  icon: _propTypes.string,
  children: _propTypes.node,

  /** Add this prop if the item is used in a Draggable component. */
  isDragItem: _propTypes.bool,
  onClick: _propTypes.func,
  otherProps: _propTypes.object
};
RiskObjectBar.defaultProps = {
  otherProps: {},
  icon: _propTypes.node,
  isDragItem: false
};
RiskObjectBar.RiskObjectBarData = RiskObjectBarDataGroup;
RiskObjectBar.RiskObjectBarData.displayName = 'RiskObjectBar.RiskObjectBarData';

var RiskObjectBarIcon = _styledComponents.default.div(_templateObject3());

var _default = RiskObjectBar;
exports.default = _default;